export enum DateTimeFormats {
  FULL = 'YYYY-MM-DD',
  FULL_WITH_MONTH_TEXT = 'DD MMMM YYYY',
  FULL_WITH_MONTH_TEXT_AND_TIME = 'DD MMMM YYYY, HH:mm',
  FULL_WITH_MONTH_TEXT_AND_DATE = 'LL',
  DAY_MONTH = 'DD MMMM',
  MONTH_DAY = 'MM-DD',
  TIME = 'HH:mm'
}
